import { combineReducers } from 'redux'
import frecMenuReducer from './Menu'
import frecUiReducer from './Ui'

export default combineReducers({
  menu: frecMenuReducer,
  ui: frecUiReducer,
})
